<svg #svgElem class="call-flow-viz-svg" [ngClass]="{'full-screen': fullScreenView}">
  <g [ngStyle]="{'transform': 'translate(' + margin.left + ',' + margin.top}"></g>
</svg>